var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0531 16.6408C24.8107 15.9591 24.3635 15.3689 23.7728 14.9511C23.1821 14.5333 22.4767 14.3083 21.7531 14.3068H19.0441C18.2713 14.3027 17.5244 14.5854 16.9479 15.1001C16.3713 15.6149 16.0062 16.3251 15.9229 17.0935C15.8397 17.8618 16.0444 18.6338 16.4973 19.26C16.9503 19.8862 17.6193 20.3223 18.3751 20.4838L22.5001 21.3838C23.3436 21.5684 24.0891 22.0583 24.5933 22.7592C25.0976 23.46 25.3251 24.3226 25.232 25.181C25.139 26.0394 24.7321 26.8331 24.0894 27.4097C23.4467 27.9863 22.6136 28.3051 21.7501 28.3048H19.4191C17.8951 28.3048 16.5991 27.3328 16.1191 25.9738M20.5861 14.3068V10.8058M20.5861 31.8058V28.3078M5.99414 41.2138V33.7138H13.4941",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.164 18.1318C40.9605 22.3774 40.3246 26.7673 38.3563 30.6125C36.3879 34.4577 33.1985 37.5404 29.2887 39.3769C25.3788 41.2134 20.9698 41.6997 16.7537 40.7594C12.5376 39.8192 8.75304 37.5056 5.99403 34.1818M1.83603 25.3078C1.0396 21.0621 1.67546 16.6722 3.64379 12.8271C5.61213 8.98188 8.80152 5.89911 12.7114 4.06261C16.6212 2.22611 21.0302 1.73984 25.2463 2.68011C29.4625 3.62039 33.247 5.93399 36.006 9.25778",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0061 2.22583V9.72583H28.5061",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.719727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures11);
export default __webpack_public_path__ + "static/media/features11.cd8a729f4d89a683e17c71788b3fe49a.svg";
export { ForwardRef as ReactComponent };